export default __webpack_public_path__ + "static/media/welcome-cny-bonus.6f2acdbc.webp";